import React, { useCallback } from 'react';
import { Modal } from 'react-bootstrap';
import { createModal } from 'react-modal-promise';
import { RouteGridPage } from './route-grid-page';

interface ModalRoutesProps {
  open: boolean;
  close: (result: any) => void;
  collectionOrderId: number;
  collectorId: number;
}

const ModalRoutes = ({ open, close, collectionOrderId, collectorId }: ModalRoutesProps) => {
  console.log('$$$ $ ModalRoutes', collectorId, collectionOrderId);
  return (
    <Modal size="xl" show={open} onHide={() => close(null)} centered backdrop="static">
      <Modal.Header closeButton className="app-modal-header">
        <Modal.Title className="app-modal-title">{`Επιλογή Προγραμματισμένων Δρομολογίων`}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="app-modal-body">
        <RouteGridPage
          collectorId={collectorId}
          collectionOrderId={collectionOrderId}
          onClose={close}
        />
      </Modal.Body>
    </Modal>
  );
};

export const promiseModalRoutes = createModal(ModalRoutes);
